/* eslint-disable jsx-a11y/accessible-emoji */
import React, { Component, Fragment } from "react";
import { Segment, Header } from "semantic-ui-react";

// import * as CONSTANTS from "../assets/Constants";
// import * as LINKS from "../assets/Links";

class Gallery extends Component {
  fid = "1lTzbxHtueqwGyBHw2Frc7nWlE4ypLfey";

  render() {
    // console.log(this.refs.container)
    return (
      <Fragment>
        <Header textAlign="center" style={{ marginTop: "1em" }} as="h2">
          <Header.Subheader style={{ fontSize: "0.7em" }}>
            <strong>Some photos from our various events over the years</strong>
          </Header.Subheader>
          <Header.Subheader style={{ fontSize: "0.5em" }}>
            The images load from Google Drive, wait for a minute 😅.
          </Header.Subheader>
        </Header>
        <Segment style={{ minHeight: 300, margin: "1em" }} raised={true}>
          <iframe
            title="rcs-drive"
            src={
              "https://drive.google.com/embeddedfolderview?id=" +
              this.fid +
              "#grid"
            }
            width={window.innerWidth - 65}
            height={window.innerHeight}
            frameBorder="0"
          />
        </Segment>
      </Fragment>
    );
  }
}

export default Gallery;
